// ============================================================
//  src/utils/helpers.js
//  Reusable helper functions
// ============================================================

import config from "../config";

/**
 * Track and return unique page visitor count using localStorage.
 */
// visitor count tracking removed — was using localStorage/sessionStorage

/**
 * Calculate cart totals.
 */
export function calcCartTotals(cart) {
  const subtotal     = cart.reduce((s, i) => s + i.price * i.qty, 0);
  const deliveryTotal = cart.reduce((s, i) => s + (i.deliveryCharge || 0), 0);
  return { subtotal, deliveryTotal, grandTotal: subtotal + deliveryTotal };
}

/**
 * Format a number as Indian currency with rupee symbol.
 * Returns a string like: "₹1,234" or "₹75"
 */
export function formatCurrency(value) {
  const n = Number(value) || 0;
  return `₹${n.toLocaleString("en-IN")}`;
}

/**
 * Build and open WhatsApp Business message with full order + bank details.
 */
export function sendOrderToWhatsApp({ user, address, cart }) {
  const { subtotal, deliveryTotal } = calcCartTotals(cart);
  const { bank } = config;

  const itemLines = cart
    .map((i) => `• ${i.name} x${i.qty} = ₹${i.price * i.qty}`)
    .join("\n");

  const message = [
    `New Order - ${config.storeName}`,
    "",
    "CUSTOMER DETAILS",
    `Name   : ${user.name}`,
    `Email  : ${user.email}`,
    `Phone  : ${user.phone}`,
    "",
    "DELIVERY ADDRESS",
    `${address.line1}, ${address.line2}`,
    `${address.city}, ${address.state} - ${address.pincode}`,
    "",
    "ORDER ITEMS",
    itemLines,
    "",
    `AMOUNT TO TRANSFER (excl. delivery) : ₹${subtotal}`,
    "",
    "PAYMENT — BANK TRANSFER",
    `Account Name   : ${bank.accountName}`,
    `Account Number : ${bank.accountNumber}`,
    `IFSC Code      : ${bank.ifscCode}`,
    `Bank           : ${bank.bankName}`,
    `Branch         : ${bank.branch}`,
    `Account Type   : ${bank.accountType}`,
    "",
    "Please transfer ₹" + subtotal + " and share the payment screenshot.",
  ].join("\n");

  const url = `https://wa.me/${config.whatsappNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
}

/**
 * Add or increment a product in the cart array.
 */
export function addItemToCart(cart, product) {
  const size = product.selectedSize || product.weight || (product.sizes && product.sizes[0]) || "default";
  const itemId = `${product.id}-${size}`;
  const exists = cart.find((i) => i.id === itemId);
  if (exists) {
    return cart.map((i) => i.id === itemId ? { ...i, qty: i.qty + 1 } : i);
  }
  const item = {
    id: itemId,
    productId: product.id,
    name: product.name,
    image: product.image,
    emoji: product.emoji,
    color: product.color,
    selectedSize: size,
    price: product.price || 0,
    deliveryCharge: product.deliveryCharge || 0,
    qty: 1,
  };
  return [...cart, item];
}

/**
 * Change quantity of a cart item; removes it if qty reaches 0.
 */
export function changeCartQty(cart, productId, delta) {
  return cart
    .map((i) => (i.id === productId ? { ...i, qty: i.qty + delta } : i))
    .filter((i) => i.qty > 0);
}
